import { PdfTemplate, TableSorting } from "components";
import moment from "moment";
import { cellValuePdf, RowExportTypePdf } from "types";
import { PropsWithChildren } from "react";
import { APPROVAL, convertNumber } from "utils";
import { ListType } from "../types";

type ExportCountType = {
  data: ListType[],
  filter: {
    dateFrom?: string | undefined,
    dateTo?: string | undefined
  },
  tableActive: TableSorting[]
}

export function ExportPdfAdjustment(props: PropsWithChildren<ExportCountType>) {
  const activeCols = props.tableActive.filter(col => col.isActive !== false)

  const columns = [
    { header: "NO", key: "no", width: 5 },
    ...activeCols
      .map(col => renderColumn(col.value as string))
      .filter((col): col is NonNullable<typeof col> => col !== undefined),
  ]

  const dataMap = props.data.map((item: any, index: number) => {
    const row: Record<string, any> = { no: index + 1 }

    activeCols.forEach(col => {
      const colMeta = renderColumn(col.value as string)
      if (colMeta) {
        row[colMeta.key] = renderCellValue(col.value as string, item)
      }
    })

    return row
  })

  return (
    <PdfTemplate
      data={dataMap}
      module="INVENTORY"
      title="REGISTER ADJUSTMENT"
      column={columns}
      date={`${moment(props.filter.dateFrom).format("DD/MM/YYYY")} - ${moment(props.filter.dateTo).format("DD/MM/YYYY")}`}
    />
  )
}

function renderColumn(title: string): { header: string; key: string | number; width: number } | undefined {
  const map: Record<string, { header: string; key: keyof RowExportTypePdf; width: number }> = {
    "trx_code": { header: "ADJUSTMENT ID#", key: "trx_code", width: 20 },
    "count_code": { header: "REF COUNT ID#", key: "count_code", width: 20 },
    "transaction_date": { header: "DATE", key: "transaction_date", width: 15 },
    "location_name": { header: "LOCATION", key: "location_name", width: 15 },
    "employee_name": { header: "TRADER", key: "employee_name", width: 30 },
    "approve_status": { header: "APPROVED", key: "approve_status", width: 15 },
    "memo": { header: "MEMO", key: "memo", width: 30 },
    "source": { header: "SOURCE", key: "source", width: 15 },
    "stock_in": { header: "STOCK IN", key: "stock_in", width: 15 },
    "stock_out": { header: "STOCK OUT", key: "stock_out", width: 15 },
    "amount": { header: "AMOUNT ADJUSTMENT", key: "amount", width: 15 },
  }
  return map[title]
}


function renderCellValue(title: string, item: any): any {
  switch (title) {
    case "trx_code":
      return item.trx_code
    case "count_code":
      return item.count_code
    case "transaction_date":
      return moment(item.transaction_date).format("DD/MM/YYYY")
    case "location_name":
      return item.location_name
    case "employee_name":
      return item.employee_name
    case "approve_status":
      return APPROVAL[item.approve_status]
    case "memo":
      return item.memo
    case "source":
      return ` ${item.source === 1 ? "COUNT ADJUSTMENT" : "DIRECT ADJUSTMENT"}`
    case "stock_in":
      return item?.stock_in ? numberFormat(Number(item.stock_in)): ""
    case "stock_out":
      return item?.stock_out ? numberFormat(Number(item.stock_out)): ""
    case "amount":
      return item?.amount_adjustment ? numberFormat(Number(item.amount_adjustment)): ""
    default:
      return item
  }
}



function numberFormat(value: number): cellValuePdf {
    return {
        text: convertNumber(value).intoCurrency,
        style: {
            textAlign: "right",
            fontWeight: "bold"
        }
    }
}